const emailVerificationByOobCode = new Map<string, Promise<unknown>>();

export function runEmailVerificationOnce<T>(
  oobCode: string,
  fn: () => Promise<T>,
): Promise<T> {
  const cached = emailVerificationByOobCode.get(oobCode);
  if (cached) {
    return cached as Promise<T>;
  }

  const promise = fn();
  emailVerificationByOobCode.set(oobCode, promise);
  return promise;
}
